import servise from '@/router/axios'

/**
 * 分页查询素材替换配置列表
 */
export const getCreativeReplaceConfigList = (params) => {
  return servise({
    url: '/creativeReplace/config/list',
    method: 'get',
    params
  })
}

/**
 * 根据ID查询替换配置
 */
export const getCreativeReplaceConfigById = (id) => {
  return servise({
    url: `/creativeReplace/config/${id}`,
    method: 'get'
  })
}

/**
 * 新增替换配置
 */
export const addCreativeReplaceConfig = (data) => {
  return servise({
    url: '/creativeReplace/config/add',
    method: 'post',
    data
  })
}

/**
 * 修改替换配置
 */
export const updateCreativeReplaceConfig = (data) => {
  return servise({
    url: '/creativeReplace/config/update',
    method: 'put',
    data
  })
}

/**
 * 删除替换配置
 */
export const deleteCreativeReplaceConfig = (idList) => {
  return servise({
    url: '/creativeReplace/config/delete',
    method: 'delete',
    params: { idList }
  })
}
